<script lang="ts">
  import { useThrelte } from '@threlte/core'
  import { useMouseEvents } from '../../hooks'
  import { focusClickedElement } from './helpers'
  import { sceneMode } from '../../stores/scene-mode'

  const { scene, renderer } = useThrelte()

  $effect(() => {
    if ($sceneMode === 'default' || $sceneMode === 'translate' || $sceneMode === 'rotate') {
      return useMouseEvents({
        onDoubleClick: e => focusClickedElement(renderer, e, scene),
      })
    }
  })
</script>
